import React from 'react'
import { observer } from 'mobx-react-lite'

import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { useGlobalCopyStore, TabContentContainer } from '../../../common'
import { useDebtsUiStore } from '../../hooks/useDebtsUiStore'

import DebtScheduleTab from './DebtScheduleTab'
import DebtDetailsTab from './DebtDetailsTab'
import DebtStatusCard from './DebtStatusCard'

const DebtDetailsContent = () => {
  const { debts: copy } = useGlobalCopyStore()
  const { showError, showCompleted } = useDebtsUiStore()
  const [tabValue, setTabValue] = React.useState(0)

  return (
    <>
      {(showError || showCompleted) && (
        <DebtStatusCard setTabValue={setTabValue} sx={{ mt: -24 }} />
      )}
      <Tabs
        aria-label={copy.details_tabs_aria_label}
        centered={true}
        onChange={(_, val) => setTabValue(val)}
        textColor="primary"
        value={tabValue}
        variant="fullWidth"
      >
        <Tab
          aria-controls="debt-schedule-tabpanel-0"
          id="debt-schedule-tab-0"
          label={copy.schedule_tab_label}
        />
        <Tab
          aria-controls="debt-details-tabpanel-1"
          id="debt-details-tab-1"
          label={copy.details_tab_label}
        />
      </Tabs>

      <TabContentContainer index={0} name="debt-schedule" value={tabValue}>
        <DebtScheduleTab />
      </TabContentContainer>

      <TabContentContainer index={1} name="debt-details" value={tabValue}>
        <DebtDetailsTab />
      </TabContentContainer>
    </>
  )
}

export default observer(DebtDetailsContent)
